__turbopack_context__.v({
  "buttonapple": "download1-module-scss-module__K6Q12W__buttonapple",
  "buttongoogle": "download1-module-scss-module__K6Q12W__buttongoogle",
  "buttons": "download1-module-scss-module__K6Q12W__buttons",
  "descriptor": "download1-module-scss-module__K6Q12W__descriptor",
  "download": "download1-module-scss-module__K6Q12W__download",
  "imgdesktopIcon": "download1-module-scss-module__K6Q12W__imgdesktopIcon",
  "imgmobileIcon": "download1-module-scss-module__K6Q12W__imgmobileIcon",
  "imgtabletIcon": "download1-module-scss-module__K6Q12W__imgtabletIcon",
  "textandbuttons": "download1-module-scss-module__K6Q12W__textandbuttons",
  "texts": "download1-module-scss-module__K6Q12W__texts",
  "title": "download1-module-scss-module__K6Q12W__title",
  "vectorIcon": "download1-module-scss-module__K6Q12W__vectorIcon",
  "vectorIcon1": "download1-module-scss-module__K6Q12W__vectorIcon1",
  "vectorIcon2": "download1-module-scss-module__K6Q12W__vectorIcon2",
  "vectorIcon3": "download1-module-scss-module__K6Q12W__vectorIcon3",
  "wrapper": "download1-module-scss-module__K6Q12W__wrapper",
});
